import React from "react";
import { Link } from "react-router-dom";
import "./signupPage.scss";
import SignupForm from "../../components/Forms/SignupForm/SignupForm";

const SignupPage = () => {
  return (
    <div className="signup__page">
      <h1>Crear cuenta</h1>
      <SignupForm />
      <div className="signup__page__link__container">
        ¿Ya tienes cuenta? <Link to="/login"> Iniciar sesión </Link>{" "}
      </div>
    </div>
  );
};

export default SignupPage;
